
import Vue, { PropType } from 'vue'
import { DeviceDetails } from '@/service/log.service'

export default Vue.extend({
  name: 'DeviceDetailsDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    device: {
      type: Object as PropType<DeviceDetails | null>,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDate (dateStr: string): string {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
    },
    getNatTypeColor (natType: string): string {
      const colors: { [key: string]: string } = {
        'Full Cone': 'success',
        'Restricted Cone': 'info',
        'Port Restricted Cone': 'warning',
        Symmetric: 'error',
        Unknown: 'grey'
      }
      return colors[natType] || 'grey'
    }
  }
})
